import React, { useState, useEffect } from 'react';
import {
  TextField, Button, Paper, Typography, Box, Snackbar, Alert, MenuItem,
  Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import { importProductsFromFile, getAllCategoryGroups } from '../../../../services/menuPage';

const ImportProductsForm = ({ onSuccess }) => {
  const [formData, setFormData] = useState({
    category_id: '',
    file: null
  });
  const [confirmOpen, setConfirmOpen] = useState(false); // جديد: نافذة تأكيد قبل الاستيراد
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    let mounted = true;
    const loadCategories = async () => {
      try {
        const res = await getAllCategoryGroups();
        const list = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
        if (mounted) setCategories(list);
      } catch (err) {
        console.error("❌ فشل في تحميل المجموعات:", err.message);
        if (mounted) setCategories([]);
      }
    };
    loadCategories();
    return () => {
      mounted = false;
    };
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: files ? files[0] : value
    }));
  };

  // عند إرسال الفورم: افتح نافذة التأكيد بدلاً من التنفيذ مباشرة
  const handleSubmit = (e) => {
    e.preventDefault();
    setMessage(null);
    // تأكد أن ملف ومجموعة محددين (التحقق الأساسي)
    if (!formData.category_id) {
      setMessage({ type: 'error', text: 'اختر المجموعة قبل الاستيراد' });
      return;
    }
    if (!formData.file) {
      setMessage({ type: 'error', text: 'اختر ملف الاستيراد' });
      return;
    }
    setConfirmOpen(true);
  };

  // عند تأكيد المستخدم: ننفّذ الاستيراد الفعلي
  const handleConfirmImport = async () => {
    setConfirmOpen(false);
    setLoading(true);
    setMessage(null);
    try {
      const result = await importProductsFromFile(formData);
      console.log("✅ نتيجة الاستيراد:", result);
      setMessage({ type: 'success', text: result.message || '✅ تم استيراد المنتجات بنجاح' });
      setFormData({ category_id: '', file: null });
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error("🚫 خطأ أثناء استيراد الملف:", error.message);
      setMessage({ type: 'error', text: error.message || 'فشل في الاستيراد' });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => setMessage(null);

  return (
    <Paper sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h6" gutterBottom>📥 استيراد المنتجات من ملف Excel</Typography>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        {/* اختيار المجموعة من القوائم المحملة */}
        <TextField
          select
          label="المجموعة"
          name="category_id"
          value={formData.category_id}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        >
          <MenuItem value="">اختر المجموعة</MenuItem>
          {categories.map((cat) => (
            <MenuItem key={cat.id} value={cat.id}>
              {cat.name || cat.category_name || `#${cat.id}`}
            </MenuItem>
          ))}
        </TextField>
        <Box mt={2}>
          <input
            type="file"
            name="file"
            accept=".xlsx, .xls"
            onChange={handleChange}
            required
          />
        </Box>
        <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }} disabled={loading}>
          {loading ? 'جارٍ الاستيراد...' : 'استيراد المنتجات'}
        </Button>
      </form>
      {/* نافذة تأكيد قبل الاستيراد */}
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>تأكيد الاستيراد</DialogTitle>
        <DialogContent>
          <Typography>
            هل تريد استيراد الملف <strong>{formData.file?.name || "—"}</strong> إلى المجموعة{" "}
            <strong>
              {categories.find(c => String(c.id) === String(formData.category_id))?.name ||
                categories.find(c => String(c.id) === String(formData.category_id))?.category_name ||
                `#${formData.category_id}`}
            </strong>
            ؟
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>إلغاء</Button>
          <Button variant="contained" color="primary" onClick={handleConfirmImport}>نعم، استيراد</Button>
        </DialogActions>
      </Dialog>

      {message && (
        <Snackbar open autoHideDuration={4000} onClose={handleCloseSnackbar}>
          <Alert onClose={handleCloseSnackbar} severity={message.type} sx={{ width: '100%' }}>
            {message.text}
          </Alert>
        </Snackbar>
      )}
    </Paper>
  );
};

export default ImportProductsForm;
